import { Box } from '@mui/material';

import { CheckIcon } from '../AcademyStatus/AcademyStatus';
import {
  phaseCompleteStatusClassNames,
  phaseCompleteStatusStyles,
} from './PhaseCompleteStatus.styles';

const statusDateFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'numeric',
  day: 'numeric',
  year: '2-digit',
});

export interface PhaseCompleteStatusProps {
  completedAt: string | null;
}

export function PhaseCompleteStatus({ completedAt }: PhaseCompleteStatusProps) {
  const formattedDate = completedAt ? formatStatusDate(completedAt) : null;
  const ariaLabel = formattedDate ? `Complete ${formattedDate}` : 'Complete';

  return (
    <Box
      component="span"
      className={phaseCompleteStatusClassNames.root}
      sx={phaseCompleteStatusStyles.root()}
      aria-label={ariaLabel}
    >
      <Box
        component="span"
        className={phaseCompleteStatusClassNames.icon}
        sx={phaseCompleteStatusStyles.icon()}
        aria-hidden="true"
      >
        <CheckIcon />
      </Box>
      <Box component="span">
        <Box component="span">Complete!</Box>
        {formattedDate ? (
          <Box
            component="span"
            className={phaseCompleteStatusClassNames.date}
            sx={phaseCompleteStatusStyles.date()}
          >
            {formattedDate}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}

function formatStatusDate(dateValue: string): string {
  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return dateValue;
  }

  return statusDateFormatter.format(date);
}
